import { openBlock as c, createElementBlock as e, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ t("path", { d: "M1.05 6.525c.15.15.34.22.53.22s.38-.07.53-.22A8.275 8.275 0 0 1 8 4.085c2.23 0 4.32.87 5.89 2.44.29.29.77.29 1.06 0 .29-.29.29-.77 0-1.06A9.749 9.749 0 0 0 8 2.585c-2.63 0-5.09 1.02-6.95 2.88-.29.29-.29.76 0 1.06Zm5.91 5.85c0 .57.47 1.04 1.04 1.04.57 0 1.04-.47 1.04-1.04 0-.57-.47-1.04-1.04-1.04-.57 0-1.04.47-1.04 1.04Z" }, null, -1), s = /* @__PURE__ */ t("path", { d: "M12.33 8.815c-.19 0-.38-.07-.53-.22A5.374 5.374 0 0 0 8 7.025c-1.43 0-2.79.56-3.8 1.57-.29.29-.77.29-1.06 0a.754.754 0 0 1 0-1.06A6.83 6.83 0 0 1 8 5.525c1.83 0 3.56.71 4.86 2.01.29.29.29.77 0 1.06-.15.15-.34.22-.53.22Z" }, null, -1), d = /* @__PURE__ */ t("path", { d: "M5.2 10.675c.15.15.34.22.53.22s.38-.07.53-.22c.93-.93 2.55-.93 3.48 0 .29.29.77.29 1.06 0 .29-.29.29-.77 0-1.06A3.925 3.925 0 0 0 8 8.455c-1.06 0-2.05.41-2.8 1.16-.29.29-.29.77 0 1.06Z" }, null, -1), l = [
  n,
  s,
  d
];
function r(_, h) {
  return c(), e("svg", o, [...l]);
}
const a = { render: r };
export {
  a as default,
  r as render
};
